export default "__VITE_ASSET__B$4HoU1s__"